<template>
<f7-page name="vehicle-gallery">
  <bc-navbar></bc-navbar>  
  <div class="layout_fullwidth_padding">
      <a href="#" @click='back()'> 
                      <img src="/static/images/icons/black/back.png" alt="" class="back_image_button" title="">
      </a>
        <div class='photo-container' v-if='isLoaded'>                             
                          <ul id="photoslist" v-bind:class="{'photo_gallery_13': imageViewId == 0, 'photo_gallery_12': imageViewId == 1, 'photo_gallery_11': imageViewId == 2}">
                              <li :image="image" v-for="(image,key) in vehicle.photos" :key="key">
                                  <a rel="gallery-3" :href='image'  class="swipebox">
                                      <img :src="image" alt="image">
                                  </a>
                              </li>
                          </ul>                                                   
          </div>
          <div style="clear:both"></div>           
          <div class="bottombarpages" :style="{ 'background-color': customization.mainColor ,  'color': customization.fontColor }">
             <div class="gallery_switch" >        
                    <a href="#" @click="changeImageView(0)" id="view13" class="switcher active">
                      <span class='icon-customer-app icon-switch13'  :style="[ imageViewId == 0 ? {  'color': customization.iconColor } : {'color':customization.fontColor }]"></span>
                      <!-- <img :src="imageViewId == 0 ? '../../../static/images/switch_13_active.png':'../../../static/images/switch_13.png'" alt="Grid"> -->
                      </a>
                    <a href="#" @click="changeImageView(1)" id="view12" class="switcher">
                      <!-- <img :src="imageViewId == 1 ? '../../../static/images/switch_12_active.png' :'../../../static/images/switch_12.png'" alt="Grid"> -->
                      <span class='icon-customer-app icon-switch12'  :style="[ imageViewId == 1 ? {  'color': customization.iconColor } : {'color':customization.fontColor }]"></span>
                      </a>
                    <a href="#" @click="changeImageView(2)" id="view11" class="switcher">
                      <!-- <img :src="imageViewId == 2 ?'../../../static/images/switch_11_active.png':'../../../static/images/switch_11.png'" alt="List"> -->
                       <span class='icon-customer-app icon-switch11'  :style="[ imageViewId == 2 ? {  'color': customization.iconColor } : {'color':customization.fontColor }]"></span>
                    </a>
                  </div>
          </div>    
    </div>     
</f7-page>
</template>

<script>

import { mapState, mapActions } from 'vuex'

export default {
  name: 'vehicale-gallery',
  components: {
  },
  mounted: function () {
    console.log(this.vehicle)
    if (this.vehicle != null) {
      this.isLoaded = true
      this.handler()
    } else {
      this.loadCurrentVehical(this.vehicleId).then(function () {
        this.isLoaded = true
        this.handler()
      }.bind(this))
    }
  },
  computed: {
    ...mapState({
      vehicle: state => state.inventory.currentVehicale,
      customization: state => state.common.customization
    })
  },
  methods: {
    ...mapActions({
      loadCurrentVehical: 'inventory/loadCurrentVehical'
    }),
    back: function () {
      this.$router.load({ url: '/vehicle/' + this.vehicle.id })
    },
    handler: function () {
      this.$nextTick(function () {
         /* eslint-disable */
        this.swipebox = $('.swipebox').swipebox()
         })
    },
    changeImageView (id) {
      this.imageViewId = id
    }
  },
  data () {
    return {
      isLoaded: false,
      vehicleId: this.$route.params.id,
      imageViewId: 0
    }
  }
}
</script>

<style scoped>
.back_image_button{
    width: 35px;
    height: 35px;
}

.img-3-row{
  width: 33.3%;
}
.img-2-row{
  width: 50%;
}
.img-1-row{
  width: 100%;
}

.image-container
{
  max-height: 80%
}
.ul.photo_gallery_13{
  margin: 15px 5% 0px 5%;
}
.tabs-animated-wrap{
  height: unset;
}
.photo_container{
  width: 90%;
  padding: 0 5%;
  display: flex;
  flex-wrap:wrap;
  margin-bottom: 70px;
} 
.photo_wrapper{
  max-height: 250px;
  margin: 5px;
}
.photo_wrapper-1{
  width: 30%;
}

.photo_wrapper-2{
  width: 45%;    
}

.photo_wrapper-3{
  width: unset;
}
.photo_gallery_13{
      padding-left: 5%;
}
ul.photo_gallery_13 li{
  margin: 5px;
  width: 27%;
}
ul.photo_gallery_12 li{
  margin: 5px;
  width: 45%;  
}
ul.photo_gallery_11 li{
  margin: 5px;
  width: unset;
}
ul.photo_gallery_13 li a img{
  height: 100%;
  max-height:250px;
  object-fit: cover;
}
ul.photo_gallery_12 li a img{
  height: 100%;
  max-height:250px;
  object-fit: cover;  
}
ul.photo_gallery_11 li a img{
  height: 100%;
  max-height:250px;
  object-fit: cover;
}

  @media (max-width: 1249px){
      .layout_fullwidth_padding{
        height: 700px !important;
        /* overflow-y: scroll !important; */
        -webkit-overflow-scrolling: touch !important ;
      }
  }
</style>




// WEBPACK FOOTER //
// vehicle-gallery.vue?5c2806ae